import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/working_dir/site/layouts/default.vue").then(m => m.default || m)),
  directory: defineAsyncComponent(() => import("/working_dir/site/layouts/directory.vue").then(m => m.default || m))
}